export default {
  edit: {
    visible: false,
  },
}
